import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { ResponsiveService } from '@frk/eds-components';
import { TranslateService } from '@shared/translate/translate.service';
import {
  ConfigurationId,
  DropdownOption,
  PerformanceViewOption,
  ToggleOption,
  ToggleProps,
} from '@types';
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import { Observable } from 'rxjs';
import { ProfileService } from '@services/profile.service';
import { PpssPriceComponent } from '@products/fund-listing/ppss/ppss-price/ppss-price.component';
export interface PerformanceComponent {
  performanceView: PerformanceViewOption;
  performanceViewOptions: PerformanceViewOption[];
  performanceAsOf: string;
  isSiteIntl?: boolean;
  periodEnd: string;
  calcType: ToggleProps | string;
  productType: ConfigurationId;
  showPerformanceCurrency: boolean;
  performanceCurrencyOptions: string[];
  selectedPerformanceCurrencyOption: string;
  updatePerformanceView: (
    view: PerformanceViewOption,
    periodEnd: string,
    performanceCurrency?: string
  ) => void;
}

export interface PriceGroupHeaderParams {
  perfTable: PpssPriceComponent;
}

@Component({
  selector: 'ft-price-group-header',
  templateUrl: './price-group-header.component.html',
  styleUrls: ['./price-group-header.component.scss'],
})
export class PriceGroupHeaderComponent implements OnChanges {
  @Input() params: PriceGroupHeaderParams; // this (using ngOnchanges) allows the switch to be used as a normal component in card view
  public ppssPriceComponent: PpssPriceComponent;
  public priceAsOf: string;

  constructor(private translateService: TranslateService) {}

  ngOnChanges(): void {
    if (this.params) {
      this.agInit(this.params);
    }
  }

  agInit(params: PriceGroupHeaderParams): void {
    this.ppssPriceComponent = params.perfTable;

    this.priceAsOf = `${this.translateService.instant('pds.PERF_AS_OF_DATE')} ${
      this.ppssPriceComponent.priceAsOf
    }`;
  }
}
